;(function () {
  'use strict';

  var config = {
    deleteClass: '.js-announcement-delete',
    itemClass: '.js-announcement-item',
    itemDataID: 'announcement-id',
    sectionClass: '.js-announcement',
  };

  $(function () {
    $(config.deleteClass).click(function () {
      var $announcementItem = $(this).parent(config.itemClass);
      var $announcement = $(this).closest(config.sectionClass);
      var itemCount = $announcement.find(config.itemClass).length;

      if (itemCount <= 1) {
        // セクションごと削除
        $announcement.fadeOut('slow', function () {
          $(this).remove();
        });
      } else {
        // 個別のお知らせを削除
        $announcementItem.fadeOut('slow', function () {
          $(this).remove();
        });
      }
    });
  });
}.call(this));
